import React from 'react';
import classnames from 'classnames';

import RadioInput from 'shared/components/RadioInput';

const RadioLabel = (props) => {
  const { label, inputId } = props;

  if (!label || label === '') {
    return null;
  }

  return (
    <label className="form-check-label" htmlFor={inputId}>
      {label}
    </label>
  );
};

const RadioComponent = (props) => {
  const {
    inputId,
    inline,
    className,
    inputClassName,
  } = props;

  return (
    <div className={classnames('form-check', { 'form-check-inline': inline }, className)}>
      <RadioInput
        {...props}
        inputClassName={classnames('form-check-input', inputClassName)}
        inputId={inputId} />
      <RadioLabel {...props} />
    </div>
  );
};

RadioComponent.defaultProps = {
  label: '',
  inline: false,
};

export default RadioComponent;
